import {getObjectFromQueryString} from '../utils/utils';
import {Primitive} from 'utility-types';

let windowProxy: any = {
    location: {
        pathname: '/',
        host: '',
        hostname: '',
        href: '',
        search: '',
        origin: '',
    },
    screen: {
        width: '',
    },
    innerwidth: 100,
    orientation: 'portrait',
    history: {
        pushState() {
            // do nothing
        },
    },
    APPLICATION_ENVIRONMENT: 'local',
};

let documentProxy: any = {
    title: 'Hibu',
    activeElement: {
        blur() {
            // do nothing
        },
    },
    getElementsByTagName(tagName: string) {
        return [];
    },
    getElementById(id: string) {
        return this[id];
    },
    getElementsByClassName(name: string) {
        return [];
    },
    addEventListener(event, listener) {
        // do nothing
    },
    createElement(type: string) {
        return {};
    },
};

let navigatorProxy = {
    userAgent: '',
};

if (typeof window !== 'undefined') {
    windowProxy = window;
    console.info("'window' available");
} else {
    console.warn("No 'window' available, using Proxy");
}

if (typeof document !== 'undefined') {
    documentProxy = document;
    console.info("'document' available");
} else {
    console.warn("No 'document' available, using Proxy");
}

if (typeof navigator !== 'undefined') {
    navigatorProxy = navigator;
    console.info("'navigator' available");
} else {
    console.warn("No 'navigator' available, using Proxy");
}

const runtimeContext = {
    getLocationPathname(): string {
        return windowProxy.location.pathname;
    },
    getLocationHost(): string {
        return windowProxy.location.host;
    },
    getLocationHostname(): string {
        return windowProxy.location.hostname;
    },
    getLocationHref(): string {
        return windowProxy.location.href;
    },
    parseBoolean(value: string): any {
        if (value === 'true') {
            return true;
        }
        if (value === 'false') {
            return false;
        }
        return value;
    },
    /**
     * Parses the browser's location query string and returns it in object form.
     *
     * @param keyTransform which function should be applied on each of the keys
     * @param valueTransform which function should be applied on each of the values
     * @param keyFilter will remove all key/value pairs which DON'T match this condition on the key AFTER transformation
     * @param valueFilter will remove all key/value pairs which DON'T match this condition on the value(s) AFTER transformation
     * @param splitMultipleValues if set to true, it will split up the values by the {@link defaultQueryDelimiter} and return an array of values instead (defaults to false)
     * @returns {@code Record<string, Primitive>} if {@code splitMultipleValues} is false, {@code Record<string, Primitive[]>} if {@code splitMultipleValues} is true
     */
    getLocationQueryObject(
        keyTransform: (key: string) => string = (key: string) => key,
        // @ts-ignore
        valueTransform: (value: string) => any = this.parseBoolean,
        keyFilter?: (key: string) => boolean,
        valueFilter?: (value: string) => boolean,
        splitMultipleValues = false
    ): Record<string, Primitive | Primitive[]> {
        return getObjectFromQueryString(
            this.getLocationQueryString(),
            keyTransform,
            valueTransform,
            keyFilter,
            valueFilter,
            splitMultipleValues
        );
    },
    getLocationQueryString(): string {
        return windowProxy.location.search;
    },
    getLocationOrigin(): string {
        return windowProxy.location.origin;
    },

    getScreenWidth(): string {
        return windowProxy.screen.width;
    },
    getWindowInnerWidth(): number {
        return windowProxy.innerWidth;
    },

    getGlobal(key: string): any {
        return windowProxy[key];
    },
    getGlobalStore(): any {
        return windowProxy;
    },
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    setGlobal(key: string, object: any): void {
        windowProxy[key] = object;
        return object;
    },

    getActiveEnvironment(): string {
        const appEnv = this.getGlobal('APPLICATION_ENVIRONMENT');
        return appEnv ? appEnv : 'local';
    },
    sendRedirect(location: string): void {
        windowProxy.location = location;
    },

    isTouchDevice(): boolean {
        return typeof windowProxy.orientation !== 'undefined' || navigatorProxy.userAgent.indexOf('IEMobile') !== -1;
    },
    setAddressbarUrl(url: string): void {
        if (this.getLocationPathname() !== url) {
            windowProxy.history.pushState({}, documentProxy.title, url);
        }
    },
    isBrowser(): boolean {
        return typeof window !== 'undefined';
    },
    document(): any {
        return documentProxy;
    },
};
export default runtimeContext;
